// utils/storage.ts
const isWeb = typeof window !== 'undefined' && typeof document !== 'undefined';
const isReactNative = typeof navigator !== 'undefined' && navigator.product === 'ReactNative';
let asyncStorage = null;
const loadAsyncStorage = async () => {
    if (!isReactNative) {
        return null;
    }
    if (!asyncStorage) {
        try {
            const { default: storageModule } = (await import('@react-native-async-storage/async-storage'));
            asyncStorage = storageModule;
        }
        catch (error) {
            console.warn('AsyncStorage not available in native environment.', error);
        }
    }
    return asyncStorage;
};
export const storage = {
    getItem: async (key) => {
        if (isWeb) {
            return localStorage.getItem(key) || sessionStorage.getItem(key);
        }
        const store = await loadAsyncStorage();
        return store ? await store.getItem(key) : null;
    },
    setItem: async (key, value, remember = false) => {
        if (isWeb) {
            const store = remember ? localStorage : sessionStorage;
            const clearStore = remember ? sessionStorage : localStorage;
            store.setItem(key, value);
            clearStore.removeItem(key);
        }
        else if (isReactNative) {
            const store = await loadAsyncStorage();
            if (store) {
                await store.setItem(key, value);
            }
        }
    },
    removeItem: async (key) => {
        if (isWeb) {
            localStorage.removeItem(key);
            sessionStorage.removeItem(key);
        }
        else if (isReactNative) {
            const store = await loadAsyncStorage();
            if (store) {
                await store.removeItem(key);
            }
        }
    },
};
//# sourceMappingURL=storage.js.map